import React, { FC } from 'react';
import { __ThankYouPageProps } from './thankYou.type';
import SuccessBg from 'assets/images/withdrawal-success.png';
import failBg from 'assets/images/withdrawal-failure.png';
import { priceDigit } from 'scripts';
import { Button } from '../../button/button.index';
import { Typography } from 'antd';
import { Alert } from '30pay/components/alert/alert.index';
export const ThankYouPage: FC<__ThankYouPageProps> = (props: __ThankYouPageProps) => {
    return (
        <div className="flex flex-col items-center justify-center gap-8">
            <img src={props.isSuccess ? SuccessBg : failBg} alt="Thank You" />
            <h1 className={`text-2xl font-bold ${props.isSuccess ? 'text-positive-dark' : 'text-negative-dark'}`}>
                {props.isSuccess ? 'پرداخت با موفقیت انجام شد!' : 'پرداخت با خطا مواجه شد!'}
            </h1>
            <div className="flex flex-col gap-4 w-full">
                {props.amount ? (
                    <div className="flex items-center gap-2">
                        <label className="w-full text-black-60 font-medium text-base">مقدار پرداخت :</label>
                        <span className="text-black-100 font-medium text-base whitespace-nowrap">
                            {priceDigit(props.amount)} تومان
                        </span>
                    </div>
                ) : null}
                {props.fee ? (
                    <div className="flex items-center gap-2">
                        <label className="w-full text-black-60 font-medium text-base">کارمزد :</label>
                        <span className="text-black-100 font-medium text-base whitespace-nowrap">
                            {priceDigit(props.fee)} تومان
                        </span>
                    </div>
                ) : null}
                {props.trackingCode ? (
                    <div className="flex items-center gap-2">
                        <label className="w-full text-black-60 font-medium text-base">شناسه پرداخت :</label>
                        <Typography.Text
                            copyable
                            className="flex flex-row-reverse gap-2 items-center whitespace-nowrap text-black-100 font-medium text-base en"
                        >
                            {props.trackingCode}
                        </Typography.Text>
                    </div>
                ) : null}
            </div>
            {props.hasAlert ?
                <Alert variant='info' style={{ whiteSpace: 'nowrap' }} message={"جهت مشاهده جزئیات سفارش، از دکمه ی صفحه ی گزارشات استفاده کنید."} />
                : null}
            <div className="flex items-center gap-2 w-full">
                <Button type="primary" className="w-full min-h-14" onClick={props.onConfirm}>
                    صفحه‌ی گزارشات
                </Button>
                <Button type="text" className="bg-background w-full min-h-14" onClick={props.onClose}>
                    بستن
                </Button>
            </div>
        </div>
    );
};
